"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGoBackRoute = exports.BackRouteContextProvider = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _usePrevious = require("../../hooks/usePrevious/usePrevious");
var BackRouteContext = /*#__PURE__*/_react.default.createContext(undefined);
var getFullUrl = function getFullUrl(location) {
  return "".concat(location.pathname).concat(location.search).concat(location.hash);
};
var useGoBackRoute = function useGoBackRoute(defaultRoute) {
  var prevRoute = (0, _react.useContext)(BackRouteContext);
  return prevRoute || defaultRoute;
};
exports.useGoBackRoute = useGoBackRoute;
var BackRouteContextProvider = function BackRouteContextProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    backRoute = _useState2[0],
    setBackRoute = _useState2[1];
  var location = (0, _reactRouterDom.useLocation)();
  var prevLocation = (0, _usePrevious.usePrevious)(location);
  (0, _react.useEffect)(function () {
    var currentUrl = location.pathname;
    var previousUrl = prevLocation && prevLocation.pathname;
    if (previousUrl && currentUrl !== previousUrl) {
      setBackRoute(getFullUrl(prevLocation));
    }
  }, [location, prevLocation]);
  return /*#__PURE__*/_react.default.createElement(BackRouteContext.Provider, {
    value: backRoute
  }, children);
};
exports.BackRouteContextProvider = BackRouteContextProvider;